module.exports = __webpack_public_path__ + "img/country-14.393f708c.jpg";